import Interest from './Interest';

export default class User {
  constructor(id = null, displayableName = null, isAnonymous = false) {
    this.id = id;
    this.displayableName = displayableName;
    this.isPremium = null;
    this.email = null;
    this.phoneNumber = null;
    this.isAnonymous = isAnonymous;

    this.interests = new Interest(this);
  }

  isOpenClassroomsStaff() {
    return !!this.email.match(/@openclassrooms.com$/);
  }
}

User.getAnonymousUser = (userId) => new User(userId, 'Anonymous', true);
